import makeStyles from '@mui/styles/makeStyles';

export default makeStyles({
  paper: {
    margin: '0 7px',
    padding: '0 7px',
  },
  mobile: {
    textAlign: 'left',
  },
});
